import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Result of interpreting natural language into a Quartz cron inner (no `cron()` wrapper).
 */
export interface SchedulerAiCronGenerateResult {
	expression: string;
	/** Optional human-readable line when the API returns one */
	description?: string;
}

/**
 * AppSync / GraphQL backend for the AI Scheduler Expression Creator.
 * Provide in the Jepto app; when absent, {@link JepSchedulerComponent} uses a Storybook-safe mock.
 */
export interface SchedulerAiCronGenerator {
	generate(prompt: string): Observable<SchedulerAiCronGenerateResult>;
}

export const SCHEDULER_AI_CRON_GENERATOR =
	new InjectionToken<SchedulerAiCronGenerator>('SCHEDULER_AI_CRON_GENERATOR');
